// const firebaseConfig = {
//   apiKey: "AIzaSyBI6chLsGI6XX67LGTXXH_gXLfngCS3aNs",
//   authDomain: "sustaingineering-horus.firebaseapp.com",
//   databaseURL: "https://sustaingineering-horus.firebaseio.com",
//   projectId: "sustaingineering-horus",
//   storageBucket: "sustaingineering-horus.appspot.com",
//   messagingSenderId: "717859757619",
//   appId: "1:717859757619:web:c59688eb51d2fec3"
// };

const firebaseConfig = {
  apiKey: "AIzaSyA8IN3r8x0FAoxQ-wNinwrzWtOCQCb7mCE",
  authDomain: "sustaingineering-horus-test.firebaseapp.com",
  projectId: "sustaingineering-horus-test",
  storageBucket: "sustaingineering-horus-test.appspot.com",
  messagingSenderId: "834615611124",
  appId: "1:834615611124:web:08828586a3a757273098a1"
};


export default firebaseConfig;